/* eslint-disable */
// @ts-nocheck

import { useContext, useState } from 'react'
import Barcode from 'react-barcode'
import { SubmitHandler, useForm } from 'react-hook-form'
import { CiBarcode } from 'react-icons/ci'

import useServer from '../../../api/useServerMain'
import Input from '../../../components/forms/Input'
import MeasureInput from '../../../components/forms/MeasureInput'
import Button from '../../../components/misc/Button'
import Modal from '../../../components/misc/GenericModal'
import { SelectInterface } from '../../../interfaces/InterfacesLocal'
import { useAppSelector } from '../../../store/hooks'
import { DetailProductContext } from '../DetailProductContainer'

const AdvancedDetails = () => {
  const { product, updateProduct, updateStockProductState } =
    useContext(DetailProductContext)
  const { productCategories, measures, salesCategories } = useAppSelector(
    (state) => state.nomenclator
  )
  const { control, handleSubmit, watch, register, getValues } = useForm()
  const { allowRoles: verifyRoles } = useServer()

  const [barCode, setBarCode] = useState<string | null>(null)

  const cubicMeasures: { key: string; value: string }[] = [
    {
      key: '1',
      value: 'm&sup3;',
    },
    {
      key: '1000000',
      value: 'cm&sup3;',
    },
  ]
  const lengthMeasures: { key: string; value: string }[] = [
    {
      key: '1',
      value: 'm',
    },
    {
      key: '0.01',
      value: 'cm',
    },
  ]

  const width = watch('width') ?? {
    quantity: 0,
    measure: lengthMeasures[0],
  }
  const length = watch('length') ?? {
    quantity: 0,
    measure: lengthMeasures[0],
  }
  const depth = watch('depth') ?? {
    quantity: 0,
    measure: lengthMeasures[0],
  }
  const cubaje = watch('cubaje') ?? {
    quantity: 0,
    measure: cubicMeasures[0],
  }

  const calculateCubaje = (inMetters = false) => {
    //Se multiplican por 10**7 y luego se divide para evitar errores de punto flotante
    if (inMetters)
      return (
        (10 ** 7 *
          width.quantity *
          width.measure *
          length.quantity *
          length.measure *
          depth.quantity *
          depth.measure) /
        10 ** 7
      )
    else
      return (
        (10 ** 7 *
          width.quantity *
          width.measure *
          length.quantity *
          length.measure *
          depth.quantity *
          depth.measure *
          cubaje.measure) /
        10 ** 7
      )
  }

  const onSubmit: SubmitHandler<Record<string, string | number | boolean>> = (
    data
  ) => {
    const dataToSend = data
    if (data.barCode === product?.barCode) {
      delete dataToSend.barCode
    }
    if (width?.quantity !== 0 && length.quantity !== 0 && depth.quantity !== 0)
      data.cubaje = calculateCubaje(true)
    else data.cubaje = cubaje.quantity / cubaje.measure

    data.width = width.quantity * width.measure
    data.length = length.quantity * length.measure
    data.depth = depth.quantity * depth.measure
    data.hasDurationEdit = true
    updateProduct && updateProduct(product?.id, data, updateStockProductState)
  }
  //------------------------------------------------------------------------

  const selectSalesCategory: SelectInterface[] = []
  salesCategories.map((cat) =>
    selectSalesCategory.push({
      name: cat.name,
      id: cat.id,
    })
  )
  selectSalesCategory.push({
    name: 'Sin categoría',
    id: null,
  })

  const selectStockCategory: SelectInterface[] = []
  productCategories?.map((cat) =>
    selectStockCategory.push({
      name: cat.name,
      id: cat.id,
    })
  )
  selectStockCategory.push({
    name: 'Sin categoría',
    id: null,
  })

  const selectMeasure: SelectInterface[] = []
  measures.map((item) =>
    selectMeasure.push({
      id: item.code,
      name: item.value,
    })
  )

  //----------------------------------------------------------------------------------------------------

  const adminRole = verifyRoles([
    'ADMIN',
    'MANAGER_COST_PRICES',
    'PRODUCT_PROCESATOR',
  ])

  const generateBarCode = () => {
    const code = '(01)' + String(product!.barCode) // Conversión explícita
    setBarCode(code)
  }

  return (
    <div>
      <div className="relative h-[34rem]">
        <div className="col-span-3 h-full overflow-auto rounded border border-gray-300 p-5 scrollbar-none">
          <form
            className="h-full w-full overflow-scroll scrollbar-thin"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className={'grid w-full grid-cols-2 gap-x-6 gap-y-2'}>
              <div>
                <Input
                  allowComma
                  control={control}
                  defaultValue={product?.grossWeight}
                  disabled={!adminRole}
                  label="Peso bruto (Kg)"
                  name="grossWeight"
                  textAsNumber
                  type="number"
                />
              </div>
              <div>
                <Input
                  allowComma
                  control={control}
                  defaultValue={product?.netWeight}
                  disabled={!adminRole}
                  label="Peso neto (Kg)"
                  name="netWeight"
                  textAsNumber
                  type="number"
                />
              </div>
              <div className="relative">
                <Input
                  control={control}
                  defaultValue={product?.barCode}
                  disabled={!adminRole}
                  label="Código de barra"
                  name="barCode"
                  noSpecialCaracters
                />
                {product?.barCode && (
                  <CiBarcode
                    className="absolute bottom-0.5 right-2 text-4xl text-gray-600 hover:scale-105 hover:cursor-pointer hover:text-gray-700"
                    onClick={generateBarCode}
                  />
                )}
              </div>
              <div>
                <Input
                  control={control}
                  defaultValue={product?.salesCode}
                  disabled={!adminRole}
                  label="Referencia"
                  name="salesCode"
                />
              </div>
              <div>
                <Input
                  control={control}
                  defaultValue={product?.branch}
                  disabled={!adminRole}
                  label="Marca"
                  name="branch"
                  type="text"
                />
              </div>
              <div>
                <Input
                  control={control}
                  defaultValue={product?.colorName}
                  disabled={!adminRole}
                  label="Color"
                  name="colorName"
                  type="text"
                />
              </div>
            </div>

            <div className={'mt-8 p-1'}>
              <h2 className={'mb-3 block font-medium text-gray-700'}>
                Medidas:
              </h2>
              <MeasureInput
                control={control}
                disabled={!adminRole}
                disabledValue={
                  width?.quantity !== 0 ||
                  length?.quantity !== 0 ||
                  depth?.quantity !== 0
                }
                label="Cubicaje"
                measures={cubicMeasures}
                name="cubaje"
                value={
                  width?.quantity !== 0 ||
                  length?.quantity !== 0 ||
                  depth?.quantity !== 0
                    ? calculateCubaje()
                    : 0
                }
                valueDefault={{
                  quantity: product?.cubaje ?? 0,
                  measure: lengthMeasures[0].key,
                }}
              />
              <div className={'mt-3 flex w-full space-x-4'}>
                <div className={'w-full'}>
                  <MeasureInput
                    {...register('length', {
                      required: {
                        value: true,
                        message: 'Las 3 medidas son necesarias',
                      },
                    })}
                    control={control}
                    disabled={!adminRole}
                    label="Largo"
                    measures={lengthMeasures}
                    valueDefault={{
                      quantity: product?.length ?? 0,
                      measure: lengthMeasures[0].key,
                    }}
                  />
                </div>
                <div className={'w-full'}>
                  <MeasureInput
                    {...register('width', {
                      required: {
                        value: length?.quantity !== 0 || depth?.quantity !== 0,
                        message: 'Las 3 medidas son necesarias',
                      },
                    })}
                    control={control}
                    disabled={!adminRole}
                    label="Ancho"
                    measures={lengthMeasures}
                    valueDefault={{
                      quantity: product?.width ?? 0,
                      measure: lengthMeasures[0].key,
                    }}
                  />
                </div>
                <div className={'w-full'}>
                  <MeasureInput
                    {...register('depth', {
                      required: {
                        value: length?.quantity !== 0 || width?.quantity !== 0,
                        message: 'Las 3 medidas son necesarias',
                      },
                    })}
                    control={control}
                    disabled={!adminRole}
                    label="Profundidad"
                    measures={lengthMeasures}
                    valueDefault={{
                      quantity: product?.depth ?? 0,
                      measure: lengthMeasures[0].key,
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="absolute -bottom-14 right-0 flex justify-end self-end pt-10">
              {adminRole && verifyRoles(['ADMIN', 'PRODUCT_PROCESATOR']) && (
                <Button color="slate-600" name="Actualizar" type="submit" />
              )}
            </div>
          </form>
        </div>
      </div>
      {barCode && (
        <Modal close={() => setBarCode(null)} state={!!barCode}>
          <div className="flex w-full flex-col items-center">
            <h5 className="font-mono">{product?.name}</h5>
            <Barcode value={barCode} />
          </div>
        </Modal>
      )}
    </div>
  )
}

export default AdvancedDetails
